export const homeRoute = '/';
export const loginRoute = '/login';
// export const qrCodeRoute = (id: string) => `/qrcodes/${id}`;
// export const createQrCodeRoute = '/create';
// export const editQrCodeRoute = (id: string) => `/${id}/edit`;
